import { Client } from 'types/clientTypes';
import { createOrg, createOrgMock } from 'utils/orgUtils';
import { createUniqueRuntimeNumber } from 'utils/uniqueRuntimeNumberUtils';
import { createPerson, createPersonMock } from 'utils/personUtils';
import { createDemoStackInfoMock } from 'utils/demoStackInfoUtils';
import { createProdStackInfoMock } from 'utils/prodStackInfoUtils';

export const createClient = (): Client => ({
  id: 0,
  org: createOrg(),
  person: createPerson(),
  position: '',
  prodStackInfo: null,
  demoStackInfo: null,
  unp: null,
});

export const createClientMock = (): Client => ({
  id: createUniqueRuntimeNumber(),
  org: createOrgMock(),
  person: createPersonMock(),
  position: 'Директор',
  prodStackInfo: createProdStackInfoMock(),
  demoStackInfo: createDemoStackInfoMock(),
  unp: '1234567890',
});
